import { IconButton } from "@mui/material";
import { AddButton } from "app/components/Button/AddButton";
import { FilterSelect } from "app/components/FilterSelect";
import { ThreedotIcon } from "app/icons";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  selectManufacturerModelManufacturerFilter,
  selectManufacturerModelMasterModelFilter,
  selectManufacturerOptions,
  selectMasterModelOptions,
} from "../../redux/selector";
import { manufacturerModelActions } from "../../redux/slice";
import { useStyles } from "./styles";

type Props = {
  onAddClick?: () => void;
};

const ActionBar = ({ onAddClick }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  const manufacturerFilter = useSelector(
    selectManufacturerModelManufacturerFilter
  );
  const masterModelFilter = useSelector(selectManufacturerModelMasterModelFilter);

  useEffect(() => {
    dispatch(manufacturerModelActions.getFilterOptions());    
  }, [dispatch]);

  const manufacturerOptions = useSelector(selectManufacturerOptions);
  const masterModelOptions = useSelector(selectMasterModelOptions);

  const getAllLabel = () => t("MANUFACTURER_MODELS.FILTERS.ALL");

  return (
    <div className={styles.root} dir="ltr">
      <div className={styles.actions}>
        <AddButton
          label={t("MANUFACTURER_MODELS.ACTIONS.ADD_MODEL")}
          onClick={onAddClick}
        />
        <IconButton size="small" className={styles.iconButton}>
          <ThreedotIcon />
        </IconButton>
      </div>

      <div className={styles.filters}>
        <FilterSelect
          label={t("MANUFACTURER_MODELS.FILTERS.MANUFACTURER.LABEL")}
          value={manufacturerFilter as string}
          options={["ALL", ...manufacturerOptions.filter((name) => name !== "")]}
          getOptionLabel={(option) => option === "ALL" ? getAllLabel() : option}
          menuMaxHeight={240}
          onChange={(value) =>
            dispatch(manufacturerModelActions.setManufacturerFilter(value))
          }
        />
        <FilterSelect
          label={t("MANUFACTURER_MODELS.FILTERS.MASTER_MODEL.LABEL")}
          value={masterModelFilter as string}
          options={["ALL", ...masterModelOptions.filter((name) => name !== "")]}
          getOptionLabel={(option) => option === "ALL" ? getAllLabel() : option}
          menuMaxHeight={240}
          onChange={(value) =>
            dispatch(manufacturerModelActions.setMasterModelFilter(value))
          }
        />
      </div>
    </div>
  );
};

export default ActionBar;
